const vehicleFieldsToPath = {
  id: "_id",
  name: "name",
  vehicleType: "vehicle_model.vehicle_type.name",
  vin: "vin",
  created: "created",
  modified: "modified",
  color: "color",
  chassisNumber: "chassis_number",
  imei: "imei.0",
  imei1: "vehicle_internals.imei1",
  vehicleImages: "images",
  licensePlate: "license_plate",
  blanketOrder: "vehicle_administration.blanket_order",
  decommissioning: "vehicle_administration.decommissioning",
  firstCommissioning: "vehicle_administration.first_commissioning",
  firstDeliver: "vehicle_administration.first_deliver",
  lastDeliver: "vehicle_administration.last_deliver",
  maintenanceContract: "vehicle_administration.maintenance_contract",
  notesFleetStatus: "vehicle_administration.notes_fleet_status",
  notesFleetSupport: "vehicle_administration.notes_fleet_support",
  vehicleModelId: "vehicle_model._id",
  brand: "vehicle_model.brand",
  images: "vehicle_model.images",
  model: "vehicle_model.model",
  version: "vehicle_model.version",
  admission: "vehicle_organization.admission",
  branch: "vehicle_organization.branch",
  externalVehicleManager: "vehicle_organization.external_vehicle_manager",
  externalVehicleManagerEmail:
    "vehicle_organization.external_vehicle_manager_email",
  externalVehicleManagerNumber:
    "vehicle_organization.external_vehicle_manager_number",
  fleetManager: "vehicle_organization.fleet_manager",
  fleetManagerEmail: "vehicle_organization.fleet_manager_email",
  fleetManagerNumber: "vehicle_organization.fleet_manager_number",
  homeBase: "vehicle_organization.home_base",
  owner: "vehicle_organization.owner",
  servicePartnerActual: "vehicle_organization.service_partner_actual",
  servicePartnerFix: "vehicle_organization.service_partner_fix",
  vehicleManager: "vehicle_organization.vehicle_manager",
  vehicleManagerEmail: "vehicle_organization.vehicle_manager_email",
  vehicleManagerNumber: "vehicle_organization.vehicle_manager_number",
  driverId: "vehicle_organization.driver_id",
  emergencyContacts: {
    field: "vehicle_organization.emergency_contacts",
    value: "name",
  },
  lastService: "vehicle_service.last_service",
  notesFleetManager: "vehicle_service.notes_fleet_manager",
  notesReport: "vehicle_service.notes_report",
  serviceIntervalKm: "vehicle_service.service_interval_km",
  serviceIntervalTime: "vehicle_service.service_interval_time",
  serviceIntervalTrigger: "vehicle_service.service_interval_trigger",
  batteryCapacity: "vehicle_technical.battery_capacity",
  drive: "vehicle_technical.drive",
  emptyWeight: "vehicle_technical.empty_weight",
  enginePower: "vehicle_technical.engine_power",
  loadingLength: "vehicle_technical.loading_length",
  loadingWidth: "vehicle_technical.loading_width",
  loadingHeight: "vehicle_technical.loading_height",
  maxSpeed: "vehicle_technical.max_speed",
  numberOfAxis: "vehicle_technical.number_of_axis",
  numberOfDoors: "vehicle_technical.number_of_doors",
  numberOfSeats: "vehicle_technical.number_of_seats",
  payload: "vehicle_technical.payload",
  range: "vehicle_technical.range",
  transmission: "vehicle_technical.transmission",
  templateId: "template_id",
  templateName: "template_name",
  customFields: "custom_fields",
  hasFleetBox: "has_fleet_box",
  isFavorite: "is_favorite",
  isReservable: "is_reservable",
  rating: "rating",
  inventoryNumber: "inventory_number",
  matriculationNumber: "matriculation_number",
  vehicleGroups: "vehicle_groups",
  tacho: "vehicle_service.tacho"
};

const vehicleFields = Object.keys(vehicleFieldsToPath);

const getFieldByPath = (data, path, defaultValue = "", valueToMap = "") =>
  path.reduce(
    (res, field) =>
      res && res[field] && !Array.isArray(res[field])
        ? res[field]
        : Array.isArray(res[field])
        ? res[field].map((x) => x[valueToMap] || "").join()
        : defaultValue,
    data,
  );

export const getVehicleFields = (data) =>
  vehicleFields.reduce(
    (result, key) => ({
      ...result,
      [key]:
        typeof vehicleFieldsToPath[key] === "string"
          ? getFieldByPath(data, vehicleFieldsToPath[key].split("."))
          : getFieldByPath(
              data,
              vehicleFieldsToPath[key].field.split("."),
              "",
              vehicleFieldsToPath[key].value,
            ),
    }),
    { initialData: data },
  );

export const setVehicleField = (vehicleData, fieldName, fieldValue) => {
  const result = vehicleData;
  const path = vehicleFieldsToPath[fieldName].split(".");
  const originFieldName = path.pop();
  const nestedObject = path.reduce((res, key) => res[key] || {}, result);
  nestedObject[originFieldName] = fieldValue;
};

export const getOrderByValue = (field) => vehicleFieldsToPath[field] || field;
